import { PostInsuranceProps } from './types';
import http from '../httpService';
import { ResourceData } from './types';

const headers = {
  accept: 'application/json, text/plain, */*',
  'content-type': 'application/json',
};

export const getBookingInfo = async (confirmId: string) => {
  const response = await http.get(
    `${process.env.REACT_APP_BASE_URL}api/booking/confirm/${confirmId}/info`,
  );
  return response;
}

export const postResource = async (data: ResourceData) => {
  const response = await http.post(
    `${process.env.REACT_APP_BASE_URL}api/resource`,
    data, { headers },
  );
  return response;
}

export const deleteResource = async (resourceId: string) => {
  const response = await http.delete(
    `${process.env.REACT_APP_BASE_URL}api/resource/${resourceId}`,
  );
  return response;
}

export const postInsurance = async (data: PostInsuranceProps) => {
  const response = await http.post(
    `${process.env.REACT_APP_BASE_URL}api/booking/insurance`,
    JSON.stringify(data), { headers },
  );
  return response;
}
